import React from 'react'
import { GptSlotManager } from './gpt-slot-manager'

export const GptSlotManagerContext = React.createContext<GptSlotManager>(
    undefined as any,
)
